export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBwhJnTkkWOh--mOYD6L34dvf4Yn_L_RvU",
    authDomain: "amacz13-whatsnext.firebaseapp.com",
    databaseURL: "https://amacz13-whatsnext.firebaseio.com",
    projectId: "amacz13-whatsnext",
    storageBucket: "amacz13-whatsnext.appspot.com",
    messagingSenderId: "352563001402"
  }
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts